/* tslint:disable */
/* eslint-disable */
/**
 * Common
 * 共通API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCostcoStores200ResponseAllOfData } from './GetCostcoStores200ResponseAllOfData';
import {
    GetCostcoStores200ResponseAllOfDataFromJSON,
    GetCostcoStores200ResponseAllOfDataFromJSONTyped,
    GetCostcoStores200ResponseAllOfDataToJSON,
} from './GetCostcoStores200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCostcoStores200Response
 */
export interface GetCostcoStores200Response {
    /**
     * 
     * @type {GetCostcoStores200ResponseAllOfData}
     * @memberof GetCostcoStores200Response
     */
    data: GetCostcoStores200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetCostcoStores200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetCostcoStores200Response interface.
 */
export function instanceOfGetCostcoStores200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCostcoStores200ResponseFromJSON(json: any): GetCostcoStores200Response {
    return GetCostcoStores200ResponseFromJSONTyped(json, false);
}

export function GetCostcoStores200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCostcoStores200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCostcoStores200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetCostcoStores200ResponseToJSON(value?: GetCostcoStores200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCostcoStores200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

